import { AvatarConsts } from './Avatar/Avatar.consts';
import { Avatar } from './Avatar';
import { CircleImage } from './CircleImage';

import type { ParticipantModel } from 'Api';

type Props = {
  displayName: string;
  color: string;
  avatarUrl?: ParticipantModel['avatar'];
  avatarSize?: string;
};

export const UserAvatar = ({
  displayName,
  color,
  avatarUrl,
  avatarSize = AvatarConsts.defaultAvatarSize
}: Readonly<Props>) =>
  avatarUrl ? (
    <CircleImage src={avatarUrl} alt="User Avatar" size={avatarSize} />
  ) : (
    <Avatar displayName={displayName} color={color} size={avatarSize} />
  );
